import { useDisclosure } from "@heroui/react";
import { toast } from "react-toastify";
import { Ticket } from "@/api/tickets/tickets.ts";
import { InputField } from "../../forms/formBuilder";
import { FormModalBuilder, ModalError } from "../formModalBuilder";
import { useState } from "react";

const updateUserToLandlordTicketFields: InputField[] = [
  {
    label: "Приоритет",
    name: "priority",
    placeholder: "",
    type: "priority",
  },
  {
    label: "Статус",
    name: "status",
    placeholder: "",
    type: "status",
  },
  {
    label: "Доступно компании",
    name: "visible_to_company",
    placeholder: "",
    type: "boolean",
  },
];

const updateToPlatformTicketFields: InputField[] = [
  {
    label: "Тема обращения",
    name: "subject",
    placeholder: "Введите тему обращения",
    type: "text",
  },
  {
    label: "Категория",
    name: "category",
    placeholder: "",
    type: "category",
  },
  {
    label: "Доступно компании",
    name: "visible_to_company",
    placeholder: "",
    type: "boolean",
  },
];

export function EditTicketModal({
  disclosure,
  ticket,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  ticket: Ticket | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors] = useState<ModalError[]>([]);

  const isUserToLandlord = ticket?.type === "user_to_landlord";
  const fields = isUserToLandlord
    ? updateUserToLandlordTicketFields
    : updateToPlatformTicketFields;

  const onSubmit = () => {
    return new Promise<boolean>((resolve) => {
      if (isUserToLandlord) {
        // Здесь нужно будет добавить метод update в API
        toast.success(
          "Функция редактирования тикетов к арендодателю пока не реализована",
        );
        disclosure.onClose();
        resolve(true);
      } else {
        // Здесь нужно будет добавить метод update в API
        toast.success(
          "Функция редактирования тикетов к платформе пока не реализована",
        );
        disclosure.onClose();
        resolve(true);
      }
    });
  };

  const getDefaultValues = () => {
    if (isUserToLandlord) {
      return {
        priority: ticket?.priority,
        status: ticket?.status,
        visible_to_company: ticket?.visible_to_company,
      };
    } else {
      return {
        subject: ticket?.subject,
        category: ticket?.category,
        visible_to_company: ticket?.visible_to_company,
      };
    }
  };

  return (
    <FormModalBuilder
      title={`Редактирование тикета ${isUserToLandlord ? "к арендодателю" : "к платформе"}`}
      fields={fields}
      isOpen={isOpen}
      isSensitiveData={true}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      submitButtonText="Сохранить"
      defaultValues={getDefaultValues()}
    />
  );
}
